import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var FontWeight = /** @class */ (function (_super) {
    __extends(FontWeight, _super);
    function FontWeight() {
        var _this = _super.call(this) || this;
        console.warn('[FontWeight] not implemented');
        return _this;
    }
    FontWeight.forceNativeConstructor = true;
    FontWeight.forceNativeMethods = true;
    // JS -> AS Bindings
    FontWeight.NORMAL = 'normal';
    FontWeight.BOLD = 'bold';
    return FontWeight;
}(ASObject));
export { FontWeight };
